import * as React from "react";
import RichTextInput from 'ra-input-rich-text';
import {
    List,
    Datagrid,
    TextField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';
import { DefaultEditCreateActions, DefaultListActions, DefaultPagination, DefaultListPerPage } from '../lib/defaultConfig';
import { DefaultFilterSidebar, IdFilter } from "../components/ListFilters";

export const TermList = props => (
    <List {...props} actions={<DefaultListActions />} pagination={<DefaultPagination />}
        perPage={DefaultListPerPage}
        aside={<DefaultFilterSidebar>
            <IdFilter />
        </DefaultFilterSidebar>}
    >
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="desc" />
        </Datagrid>
    </List>
);
export const TermEdit = props => (
    <Edit {...props} actions={<DefaultEditCreateActions/>} mutationMode={'pessimistic'}>
        <SimpleForm>
            <TextInput source="name" fullWidth />
            <RichTextInput source="desc" />
        </SimpleForm>
    </Edit>
);
export const TermCreate = props => (
    <Create {...props} actions={<DefaultEditCreateActions/>}>
        <SimpleForm>
            <TextInput source="name" fullWidth />
            <RichTextInput source="desc" />
        </SimpleForm>
    </Create>
);